export default __webpack_public_path__ + "media/american-express.b5713.png";